import React, { useEffect } from "react";
import "./LegalPage.css";
import landingLogo from "@/assets/bubble-radar-landing-logo.png";

const PUBLIC_SITE_URL = process.env.REACT_APP_PUBLIC_SITE_URL;

export default function TermsPage() {
  useEffect(() => {
    document.title = "Terms & Conditions — Bubble Radar";
  }, []);

  return (
    <div className="legal-page" data-testid="terms-page">
      <header data-testid="terms-header">
        <a className="logo" href={`${PUBLIC_SITE_URL}/`} aria-label="Bubble Radar home" data-testid="terms-logo-link">
          <img className="logo-image" src={landingLogo} alt="Bubble Radar logo" data-testid="terms-logo" />
        </a>
        <a className="back-link" href={`${PUBLIC_SITE_URL}/`} data-testid="terms-back-link">
          ← Back to home
        </a>
      </header>

      <section className="hero" data-testid="terms-hero">
        <h1 data-testid="terms-title">Terms & Conditions</h1>
        <p data-testid="terms-effective-date">Effective date: January 26, 2026</p>
      </section>

      <section className="card" data-testid="terms-card">
        <p data-testid="terms-intro">
          These terms govern your use of Bubble Radar. By accessing or using the platform, you agree to these terms.
        </p>
        <p data-testid="terms-intro-consent">By registering to the platform you agree to the Terms and Conditions.</p>

        <h2 data-testid="terms-section-use">Use of Service</h2>
        <ul data-testid="terms-use-list">
          <li>You must be at least 18 years old and able to enter a binding agreement.</li>
          <li>You are responsible for all activity conducted under your account.</li>
          <li>You agree not to misuse the service, interfere with systems, or attempt unauthorized access.</li>
        </ul>

        <h2 data-testid="terms-section-trial">Trial and Subscriptions</h2>
        <ul data-testid="terms-trial-list">
          <li>The 14‑day trial provides full access unless otherwise stated.</li>
          <li>Paid plans begin after the trial ends unless canceled beforehand.</li>
          <li>
            No refund policy: once the trial ends and a subscription has started, payments are non-refundable. The monthly subscription can be cancelled
            at any time and will run until the end of month.
          </li>
        </ul>

        <h2 data-testid="terms-section-disclaimer">Financial Disclaimer</h2>
        <p data-testid="terms-disclaimer-text">No information is provided as trading advice. You are responsible for your own decisions.</p>

        <h2 data-testid="terms-section-ip">Intellectual Property</h2>
        <p data-testid="terms-ip-text">
          All content, data, and models are owned by Bubble Radar or its licensors. You may not reproduce, distribute, or create derivative works without
          written permission.
        </p>

        <h2 data-testid="terms-section-availability">Availability</h2>
        <p data-testid="terms-availability-text">
          We strive for high uptime but do not guarantee uninterrupted service. Features may change as we improve the platform.
        </p>

        <h2 data-testid="terms-section-liability">Limitation of Liability</h2>
        <p data-testid="terms-liability-text">
          To the maximum extent permitted by law, Bubble Radar is not liable for indirect, incidental, or consequential damages resulting from use of the
          service.
        </p>

        <h2 data-testid="terms-section-contact">Contact</h2>
        <p data-testid="terms-contact-text">
          Questions? Reach out at <strong>contact@bubbleradar.com</strong>.
        </p>
      </section>

      <footer data-testid="terms-footer">
        <span data-testid="terms-footer-copy">© 2026 Bubble Radar. All rights reserved.</span>
      </footer>
    </div>
  );
}
